export const getIsError = (errorFields, rowId, field) => {
  if (!errorFields || !Array.isArray(errorFields)) return false;
  return errorFields.some(
    (error) => error.rowId === rowId && error.fields.includes(field)
  );
};
